export const SET_TEAMS = 'SET_TEAMS';
export const SET_TEAM = 'SET_TEAM';
export const ADD_TEAM = 'ADD_TEAM';
export const UPDATE_TEAM = 'UPDATE_TEAM';
export const REMOVE_TEAM = 'REMOVE_TEAM';
export const CLEAR_TEAM = 'CLEAR_TEAM';
export const CLEAR_TEAMS = 'CLEAR_TEAMS';
